module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("From Rehab to Life")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About The Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#chapter-1"
    }
  }, [_vm._v("Chapter 1")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#paradise-lost"
    }
  }, [_vm._v("Paradise Lost")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#chapter-2"
    }
  }, [_vm._v("Chapter 2")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#shades-of-the-prison-house"
    }
  }, [_vm._v("Shades of the Prison House")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#chapter-3"
    }
  }, [_vm._v("Chapter 3")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#a-mothers-love"
    }
  }, [_vm._v("A Mother’s Love")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#making-music-or-doing-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Music or Doing Time")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#an-angel-from-dominica-and-mick-jagger",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Angel from Dominica, and Mick Jagger")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#from-brotherly-love-to-crackhead-hell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Brotherly Love to Crackhead Hell")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#in-paradise-but-still-lost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Paradise – but Still Lost")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#gunfire-and-obsessing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunfire and Obsessing")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#bareback-rider",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bareback Rider")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#in-the-house-of-the-kray-twins-this-way-madness-lies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the House of the Kray Twins – This Way Madness Lies")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#happy-families",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happy Families")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#taggs-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tagg’s Island")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#from-cala-dor-to-meltdown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Cala D’or to Meltdown")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#paranoia-psychosis-and-beyond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paranoia, Psychosis and Beyond")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#crack-house-hotel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crack House Hotel")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#a-house-is-not-a-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A House is Not a Home")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#fellowships-first-stirrings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fellowship’s First Stirrings")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#resurrection-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resurrection Time")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#taking-stock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking Stock")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#a-higher-purpose",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Higher Purpose")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#in-a-dangerous-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In a Dangerous Place")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#shards-of-the-past-its-a-family-affair",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shards of the Past: It’s a Family Affair")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#salvation-sounds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvation Sounds")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch028#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch028#of-death-home-and-healing-and-the-high-court",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Of Death, Home and Healing, and the High Court")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch029#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch029#whats-new-the-awakening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s New? The Awakening")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch030#chapter-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch030#unconditional-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unconditional Love")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch031#chapter-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch031#of-death-home-and-healing-part-ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Of Death, Home and Healing, Part II")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch032#chapter-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch032#skin-im-in-the-musical-road-from-rehab-to-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skin I’m in, the Musical Road from Rehab to Life")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch033#chapter-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch033#revelations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelations")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch034#iv-appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV Appendix:")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch034#caribbean-odysseys",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caribbean Odysseys")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch035#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0